import { ReactNode, useEffect, useState } from "react";
import "../../../assets/css/filtro-generico.min.css";
import CloseIcon from "@mui/icons-material/Close";

interface IModalFiltroGenerico {
  title: string;
  localStorageFilter: string | any;
  onBack: Function;
  children?: ReactNode;
  onValueChange?: Function;
  onPropertyChange?: string | any;
  medida?: number | any;
  /**
   * Cuando es `true` el panel se dibuja en el flujo normal del documento (como el
   * de Postulaciones): se expande empujando la tabla hacia abajo en lugar de
   * taparla con un overlay absoluto. El resto de la lógica (aplicar/limpiar) es
   * idéntica. Solo lo usan las tablas de Selección Masiva y Profesional.
   */
  inline?: boolean;
}

export default (props: IModalFiltroGenerico) => {
  const {
    title,
    localStorageFilter,
    onBack,
    children,
    onValueChange,
    onPropertyChange,
    medida,
    inline,
  } = props;
  const [currenFilterStorage, setCurrentFilterStorage] = useState<any>();

  useEffect(() => {
    if (localStorage.getItem(localStorageFilter)) {
      const copyStorage: any = localStorage.getItem(localStorageFilter);
      setCurrentFilterStorage(JSON.parse(copyStorage));
    }
  }, [localStorage.getItem(localStorageFilter)]);

  const handleClickFilterApplycate = () => {
    try {
      let resultado: any = {};
      const currentData = { ...onPropertyChange };
      const currentClean = { ...onPropertyChange };
      for (const key in currentClean) {
        if (currentClean.hasOwnProperty(key)) {
          currentClean[key] = [];
        }
      }

      const copyStorageParse: any = currenFilterStorage
        ? { ...currenFilterStorage }
        : { ...currentClean };
      for (const key in currentData) {
        if (!Array.isArray(currentData[key])) {
          if (currentData[key].value !== undefined) {
            if (Array.isArray(currentData[key].value)) {
              resultado[key] = currentData[key].value.map(
                ({ code }: any) => code
              );
            } else {
              resultado[key] = [currentData[key].value.code];
            }
          } else {
            resultado[key] = [];
          }
        } else {
          resultado[key] = [...new Set(currentData[key].concat(copyStorageParse[key]))].filter(
            (value: any) => value !== null && value !== "null" && value !== undefined
          );
        }
      }

      localStorage.setItem(localStorageFilter, JSON.stringify(resultado));
      onValueChange && onValueChange(currentData);
      onBack();
    } catch (error) {
      console.log("Error al aplicar filtro");
    }
  };

  const handleClickClearFilter = () => {
    try {
      const currentData = { ...onPropertyChange };
      const currentDataFilter = { ...onPropertyChange };
      for (const key in currentData) {
        if (currentData.hasOwnProperty(key)) {
          currentData[key] = [];
        }
      }
      for (const key in currentDataFilter) {
        if (currentDataFilter.hasOwnProperty(key)) {
          if (!Array.isArray(currentDataFilter[key])) {
            currentDataFilter[key] = { value: undefined, valid: true };
          } else {
            currentDataFilter[key] = [];
          }
        }
      }
      localStorage.setItem(localStorageFilter, JSON.stringify(currentData));
      onValueChange && onValueChange(currentDataFilter);
    } catch (error) {
      console.log("error al limpiar fitro");
    }
  };

  const handleEventVerificateData = (arrayData: any) => {
    try {
      for (const key in arrayData) {
        if (arrayData.hasOwnProperty(key) && arrayData[key].length > 0) {
          return true;
        }
      }
      return false;
    } catch (error) {
      console.log("error en mostrar filtros");
    }
  };

  // Variante en línea: mismo diseño que el panel de filtros de Postulaciones. Se
  // dibuja en el flujo del documento (sin overlay absoluto) para que la tabla
  // siempre quede abajo. Los filtros aplicados ya se muestran encima de la tabla
  // (FilterChips) y dentro de cada campo, así que acá solo va "Limpiar filtros".
  if (inline) {
    return (
      <div
        style={{
          width: "100%",
          marginBottom: "16px",
          position: "relative",
          zIndex: 5,
        }}
      >
        <style>{`
          .filtro-generico-inline-grid .section-filter {
            display: flex; flex-direction: column; align-items: stretch;
            width: 100%; min-height: 0; border: none; padding: 0; gap: 6px;
          }
          .filtro-generico-inline-grid .section-filter .title {
            display: block; font-family: Roboto, sans-serif; font-size: 11px;
            font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.07em;
          }
          .filtro-generico-inline-grid .content-input-filter { width: 100%; margin-bottom: 0; position: relative; }
          .filtro-generico-inline-grid .cols-not-required { width: 100%; }
          .filtro-generico-inline-grid .input-initial {
            width: 100%; box-sizing: border-box; padding: 7px 10px; font-size: 12px;
            font-family: Roboto, sans-serif; border: 1px solid #e2e8f0; border-radius: 7px;
            outline: none; color: #334155; background: #fff;
          }
          .filtro-generico-inline-grid .input-initial:focus { border-color: #0065DD; box-shadow: 0 0 0 3px rgba(0,101,221,0.1); }
          .filtro-generico-inline-grid .section-button { display: flex; flex-wrap: wrap; gap: 6px; }
          .filtro-generico-inline-grid .section-button .button-filter {
            display: inline-flex; align-items: center; gap: 4px; padding: 5px 10px;
            border: 1px solid #cbd5e1; border-radius: 14px; background: #fff; color: #475569;
            font-family: Roboto, sans-serif; font-size: 11.5px; cursor: pointer;
          }
          .filtro-generico-inline-grid .section-button .button-filter.active { background: #0065DD; border-color: #0065DD; color: #fff; }
          .filtro-generico-inline-grid .section-button .button-filter svg { font-size: 13px; }
          .filtro-generico-inline-grid .content-input-filter .content-filter-aplicate { position: static; margin-top: 7px; display: flex; }
          .filtro-generico-inline-grid .content-button-filter-aplicate { display: flex; flex-wrap: wrap; gap: 5px; }
          .filtro-generico-inline-grid .button-filter-aplicate {
            display: inline-flex; align-items: center; gap: 4px; padding: 3px 8px 3px 10px;
            border-radius: 14px; background: #e0f2fe; border: 1px solid #bae6fd; color: #0369a1;
            font-family: Roboto, sans-serif; font-size: 11px; cursor: pointer;
          }
          .filtro-generico-inline-grid .button-filter-aplicate svg { font-size: 12px; margin: 0; color: inherit; }
        `}</style>
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: "12px",
            padding: "20px 24px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px",
              marginBottom: "14px",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontFamily: "Roboto, sans-serif",
                fontSize: "15px",
                fontWeight: 700,
                color: "#1e3a5f",
              }}
            >
              {title}
            </h2>
            <button
              type="button"
              onClick={() => onBack()}
              aria-label="Cerrar filtros"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "28px",
                height: "28px",
                borderRadius: "7px",
                border: "1px solid #e2e8f0",
                background: "#fff",
                color: "#64748b",
                cursor: "pointer",
              }}
            >
              <CloseIcon style={{ fontSize: 16 }} />
            </button>
          </div>

          <div
            className="filtro-generico-inline-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
              gap: "16px",
              alignItems: "start",
            }}
          >
            {children}
          </div>

          <footer
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "18px",
            }}
          >
            <button
              type="button"
              onClick={handleClickClearFilter}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 16px",
                borderRadius: "8px",
                border: "1px solid #cbd5e1",
                background: "#fff",
                color: "#475569",
                fontFamily: "Roboto, sans-serif",
                fontSize: "13px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Limpiar filtros
            </button>
            <button
              type="button"
              onClick={handleClickFilterApplycate}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 20px",
                borderRadius: "8px",
                border: "1px solid #0065DD",
                background: "linear-gradient(135deg, #0050b3 0%, #0065DD 100%)",
                color: "#fff",
                fontFamily: "Roboto, sans-serif",
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0,101,221,0.22)",
              }}
            >
              Aplicar
            </button>
          </footer>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-filter-group">
        <div className="modal-back-box" onClick={() => onBack()}></div>
        <div
          className={`content-filter-newdesign ${
            medida !== "" ? `filter-${medida}` : "w-100"
          }`}
        >
          <header className="container-title-filter">
            <h2>{title}</h2>
          </header>
          {handleEventVerificateData(currenFilterStorage) && (
            <section className="section-filter-aplicate">
              <div className="content-filter-aplicate">
                <span className="title-filter">Filtros Aplicados</span>
                <div className="content-button-filter-aplicate">
                  {Object.keys(currenFilterStorage).map((key) => {
                    const handleClickRemoveItem = (item: any) => {
                      const currentData = { ...currenFilterStorage };
                      const position = currentData[key]?.findIndex(
                        (state: any) => state == item
                      );
                      currentData[key].splice(position, 1);
                      setCurrentFilterStorage(currentData);
                      onValueChange && onValueChange(currentData);
                    };
                    return (
                      <>
                        {key === "tipoProceso"
                          ? null
                          : currenFilterStorage[key]
                              .flat()
                              .map((item: any, key: number) => {
                                return (
                                  <button
                                    onClick={() => handleClickRemoveItem(item)}
                                    className="button-filter-aplicate"
                                    key={key}
                                  >
                                    {item}
                                    <CloseIcon />
                                  </button>
                                );
                              })}
                      </>
                    );
                  })}
                </div>
              </div>
              <div className="content-button-filter">
                <button
                  onClick={handleClickClearFilter}
                  className="button-clear-left"
                >
                  Limpiar Filtros
                </button>
              </div>
            </section>
          )}
          <section className={`content-filter filter-${medida}`}>
            {children}
          </section>

          <footer className="modal-button-content filter">
            <button
              className={`modal-button confirm`}
              onClick={handleClickFilterApplycate}
            >
              Aplicar
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};
